<template>
  <div :id="canvasId" class="collarCanvas">
    <div class="collar-title">{{collar}}</div>
  </div>
</template>

<script>
import * as SVG from 'svg.js/dist/svg';
import { COLLARS } from '@/common/constants';
import classic from '@/assets/collars/classic.svg';

export default {
  name: 'classic',
  data () {
    return {
      COLLARS,
      id: '',
      svgId: COLLARS.CLASSIC,
      canvasId: 'classic-canvas',
      canvas: null,
      svgFile: classic,
      width: `${80}%`,
      height: `${80}%`,
    };
  },

  props: {
    collar: String,
  },

  mounted () {
    this.initCanvas();
    this.loadCollar();
  },

  computed: {
    activeCollarType () {
      return this.$store.getters['design/getCollarType'];
    },

    activeTrimPattern () {
      return this.$store.getters['design/getActiveTrimPattern'];
    },

    trimsColor () {
      return [
        {
          id: '#baseTrims',
          color: this.$store.getters['design/getBaseTrimsColor']
        },
        {
          id: '#secondaryTrims',
          color: this.$store.getters['design/getSecondaryTrimsColor']
        },
        {
          id: '#finishTrims',
          color: this.$store.getters['design/getFinishTrimsColor']
        },
      ];
    },
  },

  methods: {
    initCanvas () {
      this.canvas = SVG(this.canvasId).size(this.width, this.height);
      this.id = this.canvas.node.id;
    },

    loadSvg (svgFile) {
      return fetch(svgFile).then((response) => response.text());
    },

    loadCollar () {
      const lastCollar = this.canvas.select(`#${this.svgId}`).last();
      if (lastCollar) {
        lastCollar.remove();
      }
      this.loadSvg(classic).then((svgText) => {
        this.canvas.svg(svgText);
        this.canvas.select('svg')
          .width(`${60}%`)
          .height(`${60}%`)
          .id(this.svgId)
          .cx(this.canvas.cx())
          .cy(this.canvas.cy())
          .x(`${20}%`)
          .y(`${25}%`);
        this.trimsColor.forEach((element) => {
          this.canvas.select(element.id).fill(element.color.hex);
        });
        this.canvas.select(`#${this.activeTrimPattern}`).style('display', 'block');
      });
    },
  }
};
</script>

<style scoped>

 .collarCanvas {
   display: flex;
   flex-direction: column-reverse;
   justify-content: center;
   align-items: center;
 }

 .collar-title {
   text-transform: uppercase;
   font-size: 18px;
   font-weight: 500;
 }

</style>
